const isApple = /Mac|iPhone|iPad|iPod/.test(navigator.userAgent);

window.Ionic = {
  config: {
    mode: isApple ? 'ios' : 'md',
  },
};
